// @flow
import { getSize, getWeight } from "views/resources/theme";
import { selected } from "lib/styles";
import React from "react";
import styled from "styled-components";
import theme from "views/resources/theme";

/*
export const TimeBlockCollection = ({ name, timeBlocks, onTimeBlockClick }) => {
	const onTimeBlockClickWrapper = timeBlock => ev => onTimeBlockClick(timeBlock);
	const hourRanges = timeBlocks
		.map(tb => ({
			available: tb.available,
			key: tb.from.getTime(),
			from: toTzString(tb.from),
			to: toTzString(tb.to),
			onClick:onTimeBlockClickWrapper(tb)
		}));
	return (
		<HourRange.Group>
				{hourRanges.map( h => <HourRange.Item {...h}/>}
		<HourRange.Group>
	)
};
*/

export const TimeBlock = ({
	available,
	from,
	to,
	onClick,
	selected,
	availables,
}) => (
	<Wrapper
		onClick={available === 0 || availables === 0 ? () => {} : onClick}
		selected={selected}
	>
		<Interval>{from}</Interval>
		<AvailableSlots selected={selected}>
			{available || availables}
		</AvailableSlots>
	</Wrapper>
);

const Wrapper = styled.div`
	display: block;
	background-color: ${selected("#7d3087", "#eae9e9")};
	cursor: pointer;
	color: ${selected("#fff", "black")};
	padding: 0 0 0 10px;
	border-radius: ${getSize("xs")};
	margin: 2% 2.5%;
	font-weight: ${getWeight("semibold")};
	height: 32px;
	width: 150px;
	line-height: 32px;
	box-sizing: border-box;

	&.selected {
		background-color: ${() => theme.colors.secondary_light};
		color: #fff;
	}

	@media screen and (min-width: 768px) {
		&:hover {
			background-color: #7d3087;
			border: 2px solid #7d3087;
			color: #fff;
			line-height: 28px;
			overflow: hidden;
		}

		&:hover > div:last-child {
			background-color: #eae9e9;
			color: #7d3087;
		}

		& {
			margin: 10px 10px 10px 0;
		}
	}
`;

const Interval = styled.div`
	display: block;
	text-align: center;
	width: 70%;
	float: left;
`;

const AvailableSlots = styled.div`
	display: block;
	float: left;
	font-weight: bold;
	border-top-right-radius: ${getSize("xs")};
	border-bottom-right-radius: ${getSize("xs")};
	background-color: ${selected("#fff", "#7d3087")};
	float: right;
	color: ${selected("#7d3087", "#fff")};
	text-align: center;
	width: 32px;
`;
